<template>
  <div>
    <div class="columns  is-vcentered is-border-bottom has-bg-light"
          v-if="l.documents && l.documents.length || displayed_documents_flux && displayed_documents_flux.length">
      <div class="column is-size-6 is-padding-top-small is-padding-bottom-small">
        <span class="has-text-weight-medium">{{(l.documents.length || 0) + (displayed_documents_flux.length || 0) }} document(s)</span>
      </div>
      <!-- <div class="column is-narrow">
        <a @click.prevent.stop="downloadFile(l.documents, l.name, '.zip')"
            class="has-text-grey is-uppercase is-size-6"
            :class="{'is-loading': downloadZipLoading}">
            <span class="icon"><i class="fal fa-level-down"></i></span>
            <span>Télécharger</span>
          </a>
      </div> -->
      <a class="column has-text-white is-uppercase is-size-5 has-text-weight-medium is-narrow has-bg-success is-padding-top-small is-padding-bottom-small" v-if="documentSelected && documentsSelected.length === 1"
      target="_blank" :href="documentsSelected[0].file.path" :download="documentsSelected[0].file.filename">
          <span class="icon is-padding-right-xsmall"><i class="fas" :class="loading ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i></span>
          <span>Télécharger document</span>
      </a>
      <div @click="downloadDocuments()" style="cursor: pointer;" class="column is-narrow has-bg-success is-padding-top-small is-padding-bottom-small" v-else-if="documentSelected && documentsSelected.length > 1">
        <a class="has-text-white is-uppercase is-size-5 has-text-weight-medium">
            <span class="icon is-padding-right-xsmall"><i class="fas" :class="loading ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i></span>
            <span>Télécharger documents</span>
          </a>
      </div>
    </div>
    <table class="table is-hoverable is-fullwidth is-first-fixed-xsmall is-last-fixed-small is-marginless-bottom is-border-bottom">
      <tbody class="is-size-5 has-text-text">
        <template v-for="(d, i) in l.documents">
          <documents-list-row :key="'documentflux-'+i" :id="'documentflux-'+i" :source="d" :emailSent="isSent" @selectedItem="selectedItem"></documents-list-row>
        </template>
        <template v-for="(d, i) in displayed_documents_flux">
          <documents-list-row :key="'documentflux-'+i" :id="'documentflux-'+i" :source="d" :emailSent="isSent" @selectedItem="selectedItem"></documents-list-row>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { DownloadFile } from '@/mixins'
  import DocumentsListRow from '../../program/Tabs/DocumentsListRow'

  export default {
    name: 'LotDocumentsList',
    mixins: [DownloadFile],
    components: {
      DocumentsListRow
    },
    data () {
      return {
        loading: false
      }
    },
    props: {
      lot: {
        type: Object,
        required: true
      }
    },
    computed: {
      l () {
        return this.lot
      },
      displayed_documents_flux () {
        if (this.lot && this.lot.documents_flux && this.lot.documents_flux.length > 0) {
          return this.lot.documents_flux.filter(document => document.display)
        } return []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lot/Tabs/LotDocumentsList.vue